import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-product-cadastro',
  templateUrl: './product-cadastro.component.html',
  styleUrls: ['../../page/product/product.component.scss'],
})
export class ProductCadastroComponent {

  @Input() formulario!: FormGroup;
  @Input() nameProduct = '';

  @Output() buscarProduto = new EventEmitter<void>();
}
